import React, {Component} from 'react';
import {fetchPost} from '../cruds/remote';
import Modal from '../components/container/Modal';
import PropTypes from 'prop-types';
import {ChevronDown, ChevronUp} from 'react-feather';
import ClickOutside from 'react-click-outside';
import getLabel from '../translations/messages';
import debounce from 'lodash.debounce';
import './UserPanel.css';
import {AUTH_TIMEOUT_ENABLED, ShowBasedOnConfig} from "./container/ShowBasedOnConfig";

const formatDigits = time => (
  time < 10 ? '0' + time : time
);

const formatTime = time => {
  if (!time) {
    return '--:--';
  }

  const t = time / 1000;
  const minutes = parseInt(t / 60, 10);
  const seconds = parseInt(t % 60, 10);

  return formatDigits(minutes) + ':' + formatDigits(seconds);
};

class UserPanel extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { hidden: true };
  }

  componentDidMount = () => {
    document
      .querySelector('#root')
      .addEventListener('click', this.updateKeepAlive);

    this.initLoggedUser();
  };

  componentWillUnmount = () => {
    document
      .querySelector('#root')
      .removeEventListener('click', this.updateKeepAlive);

    clearTimeout(this.state.updateFunctionId);
  };

  updateKeepAlive = debounce(() => {
    var userInfos = JSON.parse(localStorage.loggedUser)
    if(!(userInfos.roles.includes('F') && Object.keys(userInfos.roles).length === 1) ){
      fetchPost('auth/keepalive')
        .then(res => {
          this.setState({ time: res.value });
        });
    }
  }, 500);

  initLoggedUser = () => {
    const user = JSON.parse(localStorage.loggedUser);
    user.roles.includes('F') && Object.keys(user.roles).length === 1 ? this.setState({ loggedUser: user }) : this.setState({ loggedUser: user }, this.initKeepAlive);
  };

  initKeepAlive = () => {
    fetchPost('auth/keepalive')
      .then(res => {
        this.setState({ time: res.value }, this.handleTimeUpdate);
      });
  };

  handleClick = () => {
    this.setState({ hidden: !this.state.hidden });
  };

  closeDropdown = () => {
    this.setState({ hidden: true });
  };

  handleTimeUpdate = () => {
    const updatedTime = this.state.time - 1000;
    if (updatedTime <= 0) {
      this.setState({
        time: 0,
        showModal: true,
      });
      return;
    }

    const updateFunctionId = setTimeout(this.handleTimeUpdate, 1000);
    this.setState({
      time: updatedTime,
      updateFunctionId,
    });
  };

  handleLogout = () => {
    fetchPost('auth/logout')
      .then(() => this.applyLogout);
  };

  applyLogout = () => {
    localStorage.removeItem('x-auth-token');
    localStorage.removeItem('loggedUser');
    window.location.href = '/';
  };

  renderUserName = loggedUser => (
    loggedUser ? (loggedUser.firstName + ' ' + loggedUser.lastName) : ''
  );

  renderUserRoles = loggedUser => (
    loggedUser ? loggedUser.roles
                    .map(r => getLabel(this.context.locale, 'users.roleNames.' + r))
                    .join(', ')
              : ''
  );

  renderDropdown = () => {
    if (this.state.hidden) {
      return;
    }

    return (
      <div className="dropdown-content">
        <a onClick={this.props.onRequestPasswordChange}>Change Password</a>
        <a onClick={this.handleLogout}>Logout</a>
      </div>
    );
  };

  render() {
    const { time, loggedUser } = this.state;
    return (
      <ClickOutside className="UserPanel" onClick={this.handleClick} onClickOutside={this.closeDropdown}>
        <ShowBasedOnConfig configKey={AUTH_TIMEOUT_ENABLED}>
         <div className="session-time">{formatTime(time)}</div>
        </ShowBasedOnConfig>
        <div className="user-info">
          <div className="user-name">
            {this.renderUserName(loggedUser)}
          </div>
          <div className="user-role">
            {this.renderUserRoles(loggedUser)}
          </div>
        </div>
        {this.state.hidden ? <ChevronDown size={12}/> : <ChevronUp size={12}/> }
        {this.renderDropdown()}
        <Modal isOpen={this.state.showModal}
            handleCloseModal={this.applyLogout}
            closeButtonMessage={getLabel(this.context.locale, 'general.goToLogin')}
        >
          <div style={{ padding: 20 }}>
            {getLabel(this.context.locale, 'general.sessionExpired')}
          </div>
        </Modal>
      </ClickOutside>
    );
  }
}

UserPanel.contextTypes = {
  locale: PropTypes.string,
};

export default UserPanel;



// WEBPACK FOOTER //
// ./src/main/components/UserPanel.js